/**
 * Real product screenshot in a bordered marketing frame.
 *
 * Captures live in `src/assets/marketing/`. The frame chrome matches the
 * Ink & Indigo band borders so screenshots sit inside the layout instead of
 * floating on it.
 */
export const AppShot = ({
  src,
  alt,
  label,
  caption,
}: {
  src: string;
  alt: string;
  label: string;
  caption?: string;
}) => (
  <figure className="mkt-mock overflow-hidden">
    <div className="mkt-mock-head">
      <span className="font-serif text-sm font-semibold text-foreground">{label}</span>
      {caption ? (
        <span className="hidden text-[11px] text-muted-foreground sm:inline">{caption}</span>
      ) : null}
    </div>
    <img
      src={src}
      alt={alt}
      loading="lazy"
      decoding="async"
      className="block w-full"
    />
  </figure>
);
